import React, { useCallback, useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  APP_ACTIONS,
  APP_VIEW,
} from "../../constants/constant";
import {
  fetchProducts,
  createProduct as createProductAction,
  deleteProduct as deleteProductAction,
} from "../../store/slices/dataManagement";
import { checkErrorMsg, getProductType } from "../../utils/utils";
import ModalMessageFunction from "../../common/modal-message-function";
import ToastMessageFunction from "../../common/toast-message-function";
import { useTranslation } from "../../common/translation-context";
import DMGrid from "../../common/data-grid/dmGrid";

const Product = (props) => {
  const { translate: t } = useTranslation();
  const dispatch = useDispatch();
  const { products, loading, actionLoading, error } = useSelector((state) => state.products);
  const [actionPerformed, setActionPerformed] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [productId, setProductId] = useState();
  const [newErrorBaseCode, setErrorNewBaseCode] = useState({});
  const processedBaseCodeRef = useRef(null);

  const processAction = (action, requestType) => {
    setActionPerformed(action);
    setRequestType(requestType);
  };
  const modalManager = ModalMessageFunction(processAction);
  const toastManager = ToastMessageFunction();
  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager]
  );

  const getModalAction = (requestType, requestStatus) => {
    modalManager.getModal(requestType, requestStatus);
  };

  const createProduct = async (values) => {
    let materialType = getProductType(values.productCategory);
    values = { ...values, materialType };
    try {
      await dispatch(createProductAction(values)).unwrap();
      showToast(t("addProductToast"), "success");
      dispatch(fetchProducts());
    } catch (error) {
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else showToast(t("failAddProduct"), "error");
      dispatch(fetchProducts());
    }
  };

  const deleteProductHandler = async (productId) => {
    try {
      await dispatch(deleteProductAction(productId)).unwrap();
      showToast(t("deleteSuccess"), "success");
      dispatch(fetchProducts());
    } catch (error) {
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else showToast(t("failDeleteProduct"), "error");
    }
  };

  useEffect(() => {
    if (actionPerformed && requestType === "deleteProduct") {
      deleteProductHandler(productId);
    }
    setActionPerformed(false);
    setRequestType("");
  }, [actionPerformed, productId]);

  const deleteProduct = (productId) => {
    setProductId(productId);
    getModalAction(APP_ACTIONS.DELETEPRODUCT, "deleteProduct");
  };

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  // Handle newBaseCode from props - only set once per unique baseCode
  useEffect(() => {
    if (props.newBaseCode && props.newBaseCode !== processedBaseCodeRef.current) {
      processedBaseCodeRef.current = props.newBaseCode;
      setErrorNewBaseCode({ baseCode: props.newBaseCode });
    }
  }, [props.newBaseCode]);

  useEffect(() => {
    if (error) {
      showToast(error, "error");
    }
  }, [error]);

  return (
    <>
      {modalManager.modal}
      {toastManager.toast}

      <DMGrid
        id="table"
        view={APP_VIEW.DM}
        dmView='products'
        isLoaderVisible={loading || actionLoading}
        row={products}
        header="products"
        count={products?.length}
        buttonText="addProduct"
        create={createProduct}
        delete={deleteProduct}
        errorBaseCode={newErrorBaseCode}
      />
    </>
  );
};

export default Product;
